import { canShowSketchPropertySection, registerPropertyManagerSection } from '@/core';
import SketchTrimPropertySection from '@/components/editor/property-manager/sketch-trim/SketchTrimPropertySection.vue';

registerPropertyManagerSection({
  id: 'sketch-trim',
  title: '剪裁实体',
  order: 16,
  component: SketchTrimPropertySection,
  exclusive: true,
  actions: {
    confirm: true,
    cancel: true,
  },
  isApplicable: (context) => {
    return canShowSketchPropertySection(
      context,
      context.isSketchActive
        && (
          Boolean(context.sketchTrimMode)
          || context.activeCommand === 'sketch-trim-entities'
          || context.activeCommand === 'sketch-extend-entities'
        ),
    );
  },
  onConfirm: (context) => {
    context.setSketchTrimMode?.(null);
  },
  onCancel: (context) => {
    context.setSketchTrimMode?.(null);
  },
});
